<template>
	<div class="body">
		<div class="body-container" v-if="curMenu">
			<div class="left-tabs">
				<!-- 	<div class="tab" v-for="(tab, index) in leftTabList" :key="index"
					:class="{'active-tab': activeLeftTab == index}" @click="changeLeftTab(index)">
					<div>{{ tab.name }}</div>
					<img class="active-arrow" src="../assets/icons/arrow_right2.png" />
				</div> -->
				<div class="menu-ctr">
					<VueMenu :is-collapse="isCollapse" :menu-list="leftTabList" :active-menu="defaultMenuPath"
						@collapse-change="handleCollapse" @menu-click="handleMenuClick" />
				</div>

			</div>

			<div class="right-content">
				<div class="content-title" v-if="leftTabList && leftTabList.length > 0">
					<img class="title-wing" src="../assets/icons/title_wing_left.png" />
					<span class="title-text">{{ curMenu.name }}</span>
					<img class="title-wing" src="../assets/icons/title_wing_right.png" />
				</div>

				<!-- 偏离度分析 -->
				<div class="conditions-data" v-if="leftTabList && leftTabList.length > 0">
					<template v-if="curMenu.type == 'channel'">
						<div class="thesis-cnt-ctr" v-if="curMenu.id == Channel.Thesis">
							<div class="thesis-search-ctr">
								<el-form :inline="true">
									<el-input v-model="name" placeholder="请输入名字" class="thesis-input" />
									<el-button type="primary" @click="clickConfirm()">确 定</el-button>
								</el-form>

								<el-button type="primary" icon="el-icon-message" class="el-button--success"
									@click="clickTeach()">撰写指导</el-button>
							</div>


							<el-table border :data="dataList">
								<el-table-column type="selection" min-width="1" />
								<el-table-column label="论文名称" align="center" prop="name" min-width="3" />
								<el-table-column label="作者" align="center" prop="author" min-width="1" />
								<el-table-column label="操作" align="center" prop="college_name" min-width="3">
									<template v-slot="{ row }">
										<label style="display: flex;flex-direction: row;justify-content: center;">
											<el-button type="primary" icon="el-icon-download" size="small"
												@click="clickShowMaterial(row)">下载素材</el-button>
											<el-button type="primary" size="small" icon="el-icon-message"
												class="el-button--danger" @click="clickRoute(row)">查看论文模版</el-button>
										</label>

									</template>
								</el-table-column>
							</el-table>

							<div class="pagination">
								<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
									:limit.sync="queryParams.pageSize" @pagination="requestThesisData" />
							</div>
						</div>
						<div v-else-if="curMenu.id == Channel.Industry" class="industry-ctr">
							<div class="tab-ctr">
								<label v-for="(item,index) in tabList"
									:class="['tab-item', index == tabIndex ? 'tab-item-s' : '']" :key="index"
									@click="clickAddTab(index)">{{item.name}}</label>
							</div>

							<div class="industry-cnt-ctr">
								<el-form :inline="true">
									<el-form-item label="开始">
										<el-select class="select-width-date" v-model="startYear" placeholder="请选择">
											<el-option v-for="item in thirdYearList" :key="item" :label="item"
												:value="item">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="结束">
										<el-select class="select-width-date" v-model="endYear" placeholder="请选择">
											<el-option v-for="item in thirdYearList" :key="item" :label="item"
												:value="item">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="省直辖市">
										<el-select class="select-width" v-model="province" placeholder="请选择"
											@change="changeProvince" filterable>
											<el-option v-for="item in provinceList" :key="item.province_code"
												:label="item.province_name" :value="item.province_code">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item>
										<el-button type="primary" icon="el-icon-search" size="medium"
											@click="clickRequestThirdIndustryData">搜索</el-button>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" icon="el-icon-download" size="medium"
											class="el-button--success" @click="clickExportThirdIndustryData">导
											出</el-button>
									</el-form-item>
								</el-form>

								<el-table border :data="dataList">
									<el-table-column type="selection" min-width="1" />
									<el-table-column label="年份" align="center" prop="year" />
									<el-table-column label="省直辖市" align="center" prop="province_name" />
									<el-table-column label="生产总值(亿元)" align="center" prop="amount"
										v-if="tabList[tabIndex]['value'] == 'all'" />
									<el-table-column label="常驻就业人口(万人)" align="center" prop="amount" v-else />
									<el-table-column label="第一产业" align="center" prop="first" />
									<el-table-column label="第二产业" align="center" prop="second" />
									<el-table-column label="第三产业" align="center" prop="third" />
									<el-table-column label="第一产业占比" align="center" prop="firstRate" />
									<el-table-column label="第二产业占比" align="center" prop="secondRate" />
									<el-table-column label="第三产业占比" align="center" prop="thirdRate" />

								</el-table>

								<div class="pagination">
									<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
										:limit.sync="queryParams.pageSize" @pagination="requestThirdIndustryData" />
								</div>
							</div>
						</div>
						<div v-else-if="curMenu.id == Channel.EduData" class="industry-ctr">
							<div class="tab-ctr">
								<label v-for="(item,index) in eduTabList"
									:class="['tab-item', index == tabIndex ? 'tab-item-s' : '']" :key="index"
									@click="clickAddTab(index)">{{item.name}}</label>
							</div>

							<div class="industry-cnt-ctr">
								<el-form :inline="true">
									<el-form-item label="开始">
										<el-select class="select-width-date" v-model="startYear" placeholder="请选择">
											<el-option v-for="item in eduYearList" :key="item" :label="item"
												:value="item">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="结束">
										<el-select class="select-width-date" v-model="endYear" placeholder="请选择">
											<el-option v-for="item in eduYearList" :key="item" :label="item"
												:value="item">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="省直辖市">
										<el-select class="select-width" v-model="province" placeholder="请选择"
											@change="changeProvince" filterable>
											<el-option v-for="item in provinceList" :key="item.province_code"
												:label="item.province_name" :value="item.province_code">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item>
										<el-button type="primary" icon="el-icon-search" size="medium"
											@click="clickRequestEduData">搜索</el-button>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" icon="el-icon-download" size="medium"
											class="el-button--success" @click="clickExportEduData">导 出</el-button>
									</el-form-item>
								</el-form>

								<el-table border :data="dataList">
									<el-table-column type="selection" :selectable="checkSelectable">
									</el-table-column>
									<el-table-column label="学校类型" align="center" prop="clgTypeName" />
									<el-table-column label="省直辖市" align="center" prop="province_name" />
									<el-table-column label="年份" align="center" prop="year" />
									<el-table-column label="学校数量(个)" align="center" prop="clg_num" />
									<el-table-column label="在校生数量(人)" align="center" prop="stu_num" />
									<el-table-column label="招生数量(人)" align="center" prop="enroll_num" />
									<el-table-column label="毕业生数量(人)" align="center" prop="graduate_num" />

								</el-table>

								<div class="pagination">
									<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
										:limit.sync="queryParams.pageSize" @pagination="requestEduData" />
								</div>
							</div>
						</div>
					</template>
					<template v-else-if="curMenu.type == 'data'">
						<div v-if="curMenu.id == DataType.Foregin">
							敬请期待
						</div>
					</template>
					<template v-else-if="curMenu.type == 'custom'">
						<div v-if="curMenu.id == CustomId.Industry" class="industry-cnt-ctr">
							<el-form :inline="true">

								<el-form-item label="开始">
									<el-select class="select-width-date" v-model="startYear" placeholder="请选择">
										<el-option v-for="item in yearList" :key="item" :label="item" :value="item">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="结束">
									<el-select class="select-width-date" v-model="endYear" placeholder="请选择">
										<el-option v-for="item in yearList" :key="item" :label="item" :value="item">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="省直辖市">
									<el-select class="select-width select-width-small" v-model="province"
										placeholder="请选择" @change="changeProvince" filterable>
										<el-option v-for="item in provinceList" :key="item.province_code"
											:label="item.province_name" :value="item.province_code">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="行业">
									<el-select class="select-width select-width-small" v-model="industry_code"
										placeholder="请选择" filterable>
										<el-option v-for="item in industryList" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item>
									<el-button type="primary" icon="el-icon-search" size="medium"
										@click="clickRequestIndustryData">搜索</el-button>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-download" size="medium"
										class="el-button--success" @click="clickExportIndustryData">导 出</el-button>
								</el-form-item>
							</el-form>

							<el-table border :data="dataList">
								<el-table-column type="selection" />
								<el-table-column label="年份" align="center" prop="year" min-width="1" />
								<el-table-column label="省直辖市" align="center" prop="province_name" min-width="1">
									<template v-slot="{ row }">
										<label>{{row.addrSimple.province_name}}</label>
									</template>
								</el-table-column>
								<el-table-column label="行业" align="center" prop="province_name" min-width="2">
									<template v-slot="{ row }">
										<label>{{row.industryClassify.name}}</label>
									</template>
								</el-table-column>
								<el-table-column label="企业数(个)" align="center" prop="company_num" min-width="1" />
								<el-table-column label="营业收入(亿元)" align="center" prop="company_income" min-width="1" />
								<el-table-column label="平均用工人数(万人)" align="center" prop="employee_num" min-width="1" />
							</el-table>

							<div class="pagination">
								<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
									:limit.sync="queryParams.pageSize" @pagination="requestIndustryData" />
							</div>
						</div>
						<div v-else-if="curMenu.id == CustomId.MajorMatch" class="match-ctr">

							<div class="login-ctr" v-if="hasLogin == 2">
								<div class="login-tips">该功能需要登录后才能使用</div>
								<el-button class="to-login" type="primary" icon="el-icon-s-custom"
									@click="clickLogin">点击登录</el-button>
							</div>
							<template v-else-if="hasLogin == 1">
								<div class="match-create-ctr">
									<el-button type="primary" icon="el-icon-plus" size="medium"
										@click="createUserMatch()">新建</el-button>
								</div>
								<el-table border :data="dataList">
									<el-table-column label="名称" align="center" prop="name" min-width="2" />
									<el-table-column label="省直辖市" align="center" prop="province_name" min-width="1" />
									<el-table-column label="行业" align="center" prop="province_name" min-width="1">
										<template v-slot="{ row }">
											<label>{{row.industryClassify.name}}</label>
										</template>
									</el-table-column>
									<el-table-column label="预测年限" align="center" prop="province_name" min-width="1">
										<template v-slot="{ row }">
											<label>{{row.start_year_predict}}-{{row.end_year_predict}}</label>
										</template>
									</el-table-column>
									<el-table-column label="创建日期" align="center" prop="created_at" min-width="1" />
									<el-table-column label="操作" align="center" prop="province_name" min-width="2">
										<template v-slot="{ row }">
											<el-button type="primary" icon="el-icon-reading" size="medium"
												class="el-button--success" @click="clickMatch(row)">查看</el-button>

											<el-button type="primary" icon="el-icon-delete" size="medium"
												class="el-button--danger" @click="clickDel(row)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>

							</template>


						</div>
						<div v-else-if="curMenu.id == CustomId.Job" class="match-ctr">
							<el-form :inline="true">
								<el-form-item label="学历">
									<el-select class="select-width select-width-small" v-model="degree"
										placeholder="请选择" filterable :clearable=true @change="onLevelChange">
										<el-option v-for="item in degreeList" :key="item.showName" :label="item.showName"
											:value="item.showName">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="专业">
									<el-select v-model="major" placeholder="请输入关键字" class="select-width-small" :clearable=true
										filterable remote reserve-keyword :remote-method="loadMajorList">
										<el-option v-for="item in majorList" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="省直辖市">
									<el-select class="select-width select-width-small" v-model="province"
										placeholder="请选择" @change="changeProvince" filterable :clearable=true>
										<el-option v-for="item in provinceList" :key="item.province_code"
											:label="item.province_name" :value="item.province_code">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="岗位名称">
									<el-input v-model="name" placeholder="请输入岗位名称" class="thesis-input" />
								</el-form-item>

								<el-form-item label="岗位描述">
									<el-input v-model="dsp" placeholder="请输入岗位描述" class="thesis-input" />
								</el-form-item>
								<!-- 			<el-form-item label="行业门类">
									<el-select class="select-width" v-model="sector" placeholder="请选择"
										@change="changeSector" :clearable=true >
										<el-option v-for="item in sectorTree" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
									<el-button size="medium" class="btn-filter" >已选择{{topIndustryList.length}}个</el-button>
								</el-form-item> -->
								<el-form-item label="行业大类">
									<el-button size="medium" class="btn-filter"
										@click="clickIndustry">已选择{{selectedIndustryCodeList.length}}个</el-button>
								</el-form-item>
								
								<el-form-item label="职业">
									<el-button size="medium" class="btn-filter"
										@click="clickCareer">已选择{{selectedCareerCodeList.length}}个</el-button>
								</el-form-item>

								<el-form-item>
									<el-button type="primary" icon="el-icon-search" size="medium"
										@click="clickRequestJobList">搜索</el-button>
								</el-form-item>

								<!-- <el-form-item>
									<el-button type="primary" icon="el-icon-search" size="medium"
										class="el-button--success" @click="clickExportJobData">导出</el-button>
								</el-form-item> -->

								<el-form-item>
									<el-button type="primary" icon="el-icon-document" size="medium"
										class="el-button--warning" @click="clickGenReport">生成报告</el-button>
								</el-form-item>
							</el-form>
							<el-table ref="multipleTable" border :data="dataList"
								@selection-change="handleSelectionChange" v-loading="loading"
								element-loading-text="数据可能较多，请耐心等待...">
								<el-table-column type="selection" min-width="1" />
								<el-table-column label="岗位名称" align="center" prop="name" min-width="1" />
								<el-table-column label="公司名称" align="center" prop="company_name" min-width="1" />
								<el-table-column label="省直辖市" align="center" prop="province_name" min-width="1" />
								<el-table-column label="学历" align="center" prop="degree" min-width="1" />
								<el-table-column label="薪水" align="center" prop="salary" min-width="1" />
								<el-table-column label="岗位描述" align="center" prop="description" min-width="4" />
							</el-table>

							<div class="pagination">
								<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
									:limit.sync="queryParams.pageSize" @pagination="requestJobList" />
							</div>
						</div>
						<div v-else-if="curMenu.id == CustomId.Bi" class="match-ctr">
							<el-table border :data="dataList">
								<el-table-column type="selection" min-width="1" />
								<el-table-column label="名称" align="center" prop="name" min-width="1" />
								<el-table-column label="公司名称" align="center" prop="zpCompany" min-width="1">
									<template v-slot="{ row }">

										<el-button type="primary" size="small" @click="clickRoute(row)">打开</el-button>
									</template>
								</el-table-column>

							</el-table>

							<div class="pagination">
								<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
									:limit.sync="queryParams.pageSize" @pagination="requestBiList" />
							</div>
						</div>
					</template>

				</div>
			</div>
		</div>

		<el-dialog title="论文素材" :visible.sync="showMaterialDialog" append-to-body v-if="showMaterialDialog"
			align="center">

			<el-form :inline="true" align="left">
				<el-form-item label="省直辖市">
					<el-select class="select-width" v-model="province" placeholder="请选择" @change="changeProvince"
						filterable>
						<el-option v-for="item in provinceList" :key="item.province_code" :label="item.province_name"
							:value="item.province_code">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div class="data-table">
				<el-table :data="materialList" border>
					<el-table-column prop="name" label="素材名" align="center"></el-table-column>
					<el-table-column prop="province_name" label="省直辖市" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickRoute(row)">下载</el-button>
						</template>
					</el-table-column>

				</el-table>

				<div class="pagination">
					<pagination v-show="total>0" :total="materialTotal" :page.sync="materialQueryParams.page"
						:limit.sync="materialQueryParams.pageSize" @pagination="requestMaterialData" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseDialog()">关 闭</el-button>
			</div>
		</el-dialog>

		<el-dialog title="联系客服" :visible.sync="showContact" width="45%" align="center">
			<div class="contact-ctr">

				<img class="contact-image" :src="contactUrl" />

				<div class="footer-tips">请扫码添加客服</div>

				<div class="contact-btn-ctr">
					<el-button type="primary" @click="clickClose()" size="medium">关 闭</el-button>
				</div>

			</div>

		</el-dialog>


		<el-dialog :visible.sync="showMatchDialog" title="新建匹配度分析" align='center'>
			<div class="create-group-ctr">
				<div class="group-row">
					<label>行业</label>
					<el-select class="group-select" v-model="industry_code" placeholder="请选择" :clearable=true
						filterable>
						<el-option v-for="item in industryList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</div>

				<div class="group-row">
					<label>省直辖市</label>
					<el-select class="group-select" v-model="province" placeholder="请选择" :clearable=true filterable>
						<el-option v-for="item in provinceList" :key="item.province_code" :label="item.province_name"
							:value="item.province_code">
						</el-option>
					</el-select>
				</div>

				<div class="group-row">
					<label>年份</label>
					<el-select class="group-select" v-model="year" placeholder="请选择" :clearable=true>
						<el-option v-for="item in matchYearList" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="confirmCreateMatch()">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="行业选择" :visible.sync="showIndustryDialog" append-to-body v-if="showIndustryDialog"
			align="center" @close="onIndustryDialogClosed">

			<div class="tab-ctr">
				<label v-for="(item,index) in groupAddList"
					:class="['tab-item', index == groupAddIndex ? 'tab-item-s' : '']" :key="index"
					@click="clickIndustryTab(index)">{{item.name}}</label>
			</div>

			<el-form :inline="true" align="left">
				<el-form-item label="行业门类">
					<el-select v-model="sector" placeholder="请输入关键字" class="select-group-width" filterable remote
						:clearable=true reserve-keyword @change="changeSector">
						<el-option v-for="item in sectorTree" :key="item.code" :label="item.name" :value="item.code" />
					</el-select>
				</el-form-item>

			</el-form>

			<div class="data-table">
				<el-table :data="childIndustryList" border>
					<el-table-column prop="name" label="行业大类" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickAddIndustry(row.code)"
								v-if="!isIndustrySelected(row.code)">添加</el-button>
							<el-button type="warning" size="small" @click="clickRemoveIndustry(row.code)"
								v-else>移除</el-button>
						</template>
					</el-table-column>

				</el-table>
				
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIndustryDialog()">确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="职业选择" :visible.sync="showCareerDialog" append-to-body v-if="showCareerDialog"
			align="center" >
		
			<div class="tab-ctr">
				<label v-for="(item,index) in groupAddList"
					:class="['tab-item', index == groupAddIndex ? 'tab-item-s' : '']" :key="index"
					@click="clickCareerTab(index)">{{item.name}}</label>
			</div>
		
			<el-form :inline="true" align="left">
				<el-form-item label="行业大类">
					<el-select v-model="dialogIndustry" placeholder="请输入关键字" class="select-group-width" filterable remote
						:clearable=true reserve-keyword @change="changeIndustry">
						<el-option v-for="item in bigIndustryList" :key="item.code" :label="item.name" :value="item.code" />
					</el-select>
				</el-form-item>
		
			</el-form>
		
			<div class="data-table">
				<el-table :data="careerList" border>
					<el-table-column prop="name" label="职业" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickAddCareer(row.career_code)"
								v-if="row.isAdd != 1">添加</el-button>
							<el-button type="warning" size="small" @click="clickRemoveCareer(row.career_code)"
								v-else>移除</el-button>
						</template>
					</el-table-column>
		
				</el-table>
				
				<div class="pagination">
					<pagination v-show="careerParams.total>0" :total="careerParams.total" :page.sync="careerParams.page"
						:limit.sync="careerParams.pageSize" @pagination="loadCareerList" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseCareerDialog()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getChannel,
		getCorrelationMenu,
		queryCollege,
		calcuCorrelation,
		getThesisData,
		getMaterialData,
		getThirdIndustryData,
		getEduData,
		getIndustryData,
		getServiceConfigData,
		exportIndustryData,
		exportThirdIndustryData,
		exportEduData,
		createMajorMatch,
		getMajorMatchList,
		getJobList,
		delMatch,
		queryCareerList
	} from "@/api/service"

	import {
		getAddrTree,
		exportGroupJobData,
		getMajorList
	} from "@/api/matrix"

	import {
		getBiList
	} from "@/api/bis"

	import {
		isEmpty,
		setLocalData,
		getLocalData
	} from "@/utils/util"

	import {
		useLoginStore
	} from "@/utils/login"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'


	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	const DEFAULT_SERVICE_MENU = 'DEFAULT_SERVICE_MENU'

	export default {
		name: "Service",
		data() {
			return {
				name: '',
				leftTabList: [],
				activeLeftTab: 0,
				reportList: [],
				tabIndex: 0,
				dataList: [],
				materialList: [],
				queryParams: {
					page: 1,
					pageSize: 20
				},
				materialQueryParams: {
					page: 1,
					pageSize: 10
				},
				province: '',
				provinceList: [],
				showMaterialDialog: false,
				docId: '',
				total: 0,
				materialTotal: 0,
				Channel: {
					Thesis: 6,
					EduData: 7,
					Industry: 8
				},
				DataType: {
					Foregin: 20
				},
				CustomId: {
					Industry: 999999,
					MajorMatch: 8888881,
					Job: 777777,
					Bi: 666666
				},
				tabList: [{
						'name': '生产总值',
						'value': 'all'
					},
					{
						'name': '就业人口',
						'value': 'people'
					},
				],
				eduTabList: [{
						'name': '中职学校',
						'value': 'middle'
					},
					{
						'name': '高职专科',
						'value': 'high'
					},
					{
						'name': '职业本科',
						'value': 'vtl_uge'
					},
					{
						'name': '普通本科',
						'value': 'normal_ben'
					},
				],
				eduDataTypeList: [{
						'name': '学校数量',
						'value': 'college_num'
					},
					{
						'name': '学生数量',
						'value': 'student_num'
					},
					{
						'name': '招生数量',
						'value': 'enrollment_num'
					},
					{
						'name': '毕业生数量',
						'value': 'graduate_num'
					},
				],
				data_type: '',
				showContact: false,
				wxUrl: 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202510/16234435-85480558676586283.jpg',
				qqUrl: 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202510/16234435-85480558676586283.jpg',
				contactUrl: '',
				startYear: '',
				endYear: '',
				yearList: [],
				matchYearList: [],
				thirdYearList: [],
				eduYearList: [],
				industryList: [],
				industry_code: '',
				isCollapse: false,
				curMenu: null,
				dsp: '',
				degreeList: null,
				degree: '',
				showMatchDialog: false,
				year: '',
				hasLogin: 3,
				selectJobMap: {},
				defaultMenuPath: '',
				sectorTree: [],
				childIndustryList: [],
				sector: '',
				career_code: '',
				careerList: [],
				loading: true,
				selectedIndustryCodeList: [],
				selectedCareerCodeList: [],
				showIndustryDialog: false,
				showCareerDialog: false,
				groupAddList: [{
						'name': '未添加',
						'value': 2
					},
					{
						'name': '已添加',
						'value': 1
					},
				],
				groupAddIndex: 0,
				dialogIndustry: 0,
				careerParams: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				majorList: [],
				major: ''
			}
		},

		setup() {
			const loginStore = useLoginStore()

			// 返回 store 到模板中使用
			return {
				loginStore
			}
		},

		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				getChannel().then(res => {
					this.leftTabList = res.data.channelList;
					// this.curMenu = this.leftTabList[0]

					let defaultMenu = getLocalData(DEFAULT_SERVICE_MENU)
					let menu = null;
					if (defaultMenu) {
						menu = JSON.parse(defaultMenu)

						if (menu) {
							setLocalData(DEFAULT_SERVICE_MENU, '')
						}
					}

					let params = this.$route.query
					if (!menu) {
						let index = 0;
						if (!isEmpty(params.activeLeftTab) && params.activeLeftTab >= 0 && params.activeLeftTab <
							this.leftTabList.length) {
							index = params.activeLeftTab;
						}
						menu = this.leftTabList[index];
					}

					let tabIndex = -1;
					if (params.tabIndex >= 0) {
						tabIndex = params.tabIndex;
					}

					this.curMenu = menu;

					this.defaultMenuPath = this.curMenu['path']
					this.changeLeftTab(tabIndex);
				});

				this.loadConfig();
			},

			handleCollapse(val) {
				this.isCollapse = val
			},
			handleMenuClick(item) {
				console.log('handleMenuClick1111111', item)
				this.curMenu = item;
				this.changeLeftTab();
			},

			onMenuClick(item) {
				console.log('点击菜单:', item)
				// 路由跳转等操作
			},
			onCollapseChange(collapsed) {
				console.log('菜单收缩状态:', collapsed)
			},

			changeLeftTab(tabIndex = -1) {
				this.columnList = [];
				this.dataList = [];
				this.total = 0;
				this.queryParams = {
					page: 1,
					pageSize: 20
				}
				if (tabIndex >= 0) {
					this.tabIndex = tabIndex;
				} else {
					this.tabIndex = 0;
				}
				this.startYear = '';
				this.endYear = '';
				this.name = '';

				let tab = this.curMenu;
				let id = tab['id'];

				if (tab['type'] == 'channel') {
					if (id == this.Channel.Thesis) {
						this.requestThesisData();
					} else if (id == this.Channel.EduData) {
						this.startYear = this.eduYearList[0];
						this.endYear = this.startYear;
						this.province = this.provinceList[0]['province_code'];
						this.requestEduData();
					} else if (id == this.Channel.Industry) {
						this.startYear = this.thirdYearList[0];
						this.endYear = this.startYear;
						this.province = this.provinceList[0]['province_code'];
						this.requestThirdIndustryData();
					}
				} else if (tab['type'] == 'data') {
					// if (id == this.DataType.Foregin) {

					// }
				} else if (tab['type'] == 'custom') {
					if (id == this.CustomId.Industry) {
						this.startYear = this.yearList[0];
						this.endYear = this.startYear;
						this.province = this.provinceList[0]['province_code'];
						this.requestIndustryData();
					} else if (id == this.CustomId.MajorMatch) {
						this.requestMajorMatch();
					} else if (id == this.CustomId.Job) {
						this.selectJobMap = {}
						this.requestJobList();
					} else if (id == this.CustomId.Bi) {
						this.requestBiList();
					}
				}
			},

			buildParams() {
				this.queryParams['degree'] = this.degree;
				this.queryParams['name'] = this.name;
				this.queryParams['dsp'] = this.dsp;
				this.queryParams['province_code'] = this.province;
				this.queryParams['industry_codes'] = this.selectedIndustryCodeList.join(',');
				this.queryParams['career_codes'] = this.selectedCareerCodeList.join(',');
				this.queryParams['year_value'] = this.year;
				this.queryParams['top_industry_code'] = this.sector;
				this.queryParams['major'] = this.major;

				return this.queryParams;
			},

			clickRequestJobList() {
				this.queryParams['page'] = 1;
				this.requestJobList();
			},

			requestJobList() {
				this.dataList = [];
				this.loading = true;
				getJobList(this.buildParams()).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
					this.$nextTick(() => {
						this.setDefaultSelection();
					})
					this.loading = false;
				});
			},

			requestBiList() {
				this.dataList = [];
				this.total = 0;
				getBiList(this.buildParams()).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			requestMajorMatch() {
				getMajorMatchList(this.buildParams()).then(res => {
					this.hasLogin = res.data.hasLogin;
					if (this.hasLogin == 1) {
						this.dataList = res.data.list;
						this.total = res.data.pageData.totalCount;
					}
				});
			},

			clickRequestEduData() {
				console.log('dateRange', this.dateRange)
				this.queryParams['page'] = 1;
				this.requestEduData();
			},

			clickRequestIndustryData() {
				console.log('dateRange', this.dateRange)
				this.queryParams['page'] = 1;
				this.requestIndustryData();
			},

			clickExportIndustryData() {
				this.initParams();
				exportIndustryData(this.queryParams).then(res => {
					let realData = res.data;

					window.open(realData.url, '_blank')
				})
			},

			clickExportEduData() {
				this.initParams();
				exportEduData(this.queryParams).then(res => {
					let realData = res.data;

					window.open(realData.url, '_blank')
				})
			},


			clickExportThirdIndustryData() {
				this.initParams();
				exportThirdIndustryData(this.queryParams).then(res => {
					let realData = res.data;

					window.open(realData.url, '_blank')
				})
			},

			requestThesisData() {
				this.initParams();
				getThesisData(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			requestEduData() {
				this.initParams();
				getEduData(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			clickRequestThirdIndustryData() {
				this.queryParams['page'] = 1;
				this.requestThirdIndustryData();
			},

			requestThirdIndustryData() {
				this.initParams();
				getThirdIndustryData(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			requestIndustryData() {
				this.initParams();
				getIndustryData(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				})
			},

			initParams() {

				this.queryParams['name'] = this.name;
				this.queryParams['province_code'] = this.province;
				this.queryParams['data_type'] = this.data_type;

				let tab = this.curMenu;
				let type = tab.type;
				let id = tab.id;

				if (type == 'custom') {
					if (id == this.CustomId.Industry) {
						this.queryParams['industry_code'] = this.industry_code;
					}
				} else {
					if (id == this.Channel.EduData) {
						this.queryParams['clg_type'] = this.eduTabList[this.tabIndex]['value'];
					} else if (id == this.Channel.Industry) {
						this.queryParams['type'] = this.tabList[this.tabIndex]['value'];
					}
				}


				this.queryParams['startYear'] = this.startYear;
				this.queryParams['endYear'] = this.endYear;
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},

			clickCloseDialog() {
				this.showMaterialDialog = false;
			},

			clickShowMaterial(row) {
				this.docId = row.id;
				this.materialQueryParams['doc_id'] = this.docId;
				this.showMaterialDialog = true;
				this.materialList = [];
				this.province = ''
				this.requestMaterialData();
			},

			loadConfig() {
				getServiceConfigData().then(res => {
					this.provinceList = res.data.tree;
					this.yearList = res.data.yearList;
					this.thirdYearList = res.data.thirdYearList;
					this.eduYearList = res.data.eduYearList;
					this.industryList = res.data.industryList;
					this.degreeList = res.data.degreeList;
					this.matchYearList = res.data.matchYearList;
					this.sectorTree = res.data.industryTree;
				});
			},

			requestMaterialData() {
				this.initMaterialParams();
				getMaterialData(this.materialQueryParams).then(res => {
					this.materialList = res.data.list;
					this.materialTotal = res.data.pageData.totalCount;
				});
			},

			initMaterialParams() {
				this.materialQueryParams['province_code'] = this.province;
			},

			changeProvince(value) {
				let id = this.curMenu.id;

				if (id == this.Channel.Industry) {
					// this.requestThirdIndustryData();
				} else if (id == this.Channel.EduData) {
					// this.requestEduData();
				} else if (this.showMaterialDialog) {
					this.requestMaterialData();
				}
			},

			changeDataType() {
				this.requestEduData();
			},

			clickAddTab(index) {
				this.queryParams.page = 1;
				this.tabIndex = index;

				let id = this.curMenu.id;

				if (id == this.Channel.EduData) {
					this.requestEduData();
				} else if (id == this.Channel.Industry) {
					this.requestThirdIndustryData();
				}
			},

			clickTeach() {
				let type = 'weixin';
				if (type == 'qq') {
					this.contactUrl = this.qqUrl;
				} else {
					this.contactUrl = this.wxUrl;
				}
				this.showContact = true;
			},

			clickClose() {
				this.showContact = false;
			},

			//-----------match----------	

			createUserMatch() {
				this.year = '';
				this.province = '';
				this.showMatchDialog = true;
			},

			confirmCreateMatch() {
				createMajorMatch(this.buildParams()).then(res => {
					this.showMatchDialog = false;
					this.changeLeftTab();
				})
			},

			clickMatch(row) {
				let path = '/data_source?id=' + row.id;
				this.$router.push(path);
			},

			clickDel(row) {
				this.$modal.confirm('确定要删除该条数据吗？').then(() => {
					delMatch({
						'id': row.id
					}).then(res => {
						this.changeLeftTab();
					})
				})
			},


			clickLogin() {
				setLocalData(DEFAULT_SERVICE_MENU, JSON.stringify(this.curMenu))
				this.loginStore.openLoginDialog()
			},

			clickGenReport() {
				let list = this.getSelectedJobIdMap();

				if (list.length < 1) {
					Message({
						message: '请先选择岗位',
						type: 'error',
						zIndex: 300000
					})
					return;
				}

				let path = '/job_report?ids=' + list.join(',');
				this.$router.push(path);
			},

			clickExportJobData() {
				let list = this.getSelectedJobIdMap();

				if (list.length < 1) {
					Message({
						message: '请先选择岗位',
						type: 'error',
						zIndex: 300000
					})
					return;
				}

				let params = {
					'ids': list.join(',')
				}

				exportGroupJobData(params).then(res => {
					let realData = res.data;

					window.open(realData.url, '_blank')
				})
			},

			getSelectedJobIdMap() {
				let list = [];

				Object.keys(this.selectJobMap).forEach(id => {
					if (this.selectJobMap[id]) {
						list.push(id)
					}
				})

				return list;
			},


			handleSelectionChange(val) {
				if (this.isSettingDefault) {
					// 如果是设置默认选中，跳过业务逻辑
					console.log('正在设置默认选中，跳过处理')
					return
				}

				console.log('handleSelectionChange before val', val)
				this.dataList.forEach(row => {
					let value = val.some(selected => selected.id === row.id);
					this.selectJobMap[row.id] = value;
				})

				console.log('handleSelectionChange after this.selectJobMap', this.selectJobMap)
			},

			setDefaultSelection() {
				this.isSettingDefault = true // 设置标志	
				console.log('setDefaultSelection this.selectJobMap', this.selectJobMap)
				this.dataList.forEach(row => {
					if (this.selectJobMap[row.id]) {
						console.log('setDefaultSelection id: ', row.id)
						this.$refs.multipleTable.toggleRowSelection(row, true)
					}
				})

				// 使用 nextTick 确保所有选中操作完成后再重置标志
				this.$nextTick(() => {
					this.isSettingDefault = false
				})
			},

			checkSelectable(row, index) {
				return true;
			},

			changeSector(value) {
				console.log('province: ', value);
				this.sectorTree.forEach(element => {
					if (element.code == value) {
						this.industry_code = '';
						this.showValidIndustryList(element.list);
						this.careerList = [];
					}
				});
			},

			changeIndustry() {
				this.careerList = [];
				this.career_code = '';
				this.loadCareerList();
			},

			loadCareerList() {
				this.careerParams.industry_code = this.dialogIndustry;
				this.careerParams.isAdd = this.groupAddList[this.groupAddIndex]['value']
				this.careerParams.career_codes = this.selectedCareerCodeList.join(',')
				queryCareerList(this.careerParams).then(res => {
					this.careerList = res.data.list;
					this.careerParams.total = res.data.pageData.totalCount;
					
					console.log('this.careerParams', this.careerParams)
				});
			},

			changeCareer() {

			},

			clickIndustry() {
				this.showIndustryDialog = true;
				// this.selectedIndustryCodeList = [];
				this.sector = this.sectorTree[0]['code'];
				this.changeSector(this.sector);
			},

			onIndustryDialogClosed() {
				this.selectedCareerCodeList = [];
			},


			clickCloseIndustryDialog(){
				this.showIndustryDialog = false;
				this.onIndustryDialogClosed();
			},

			clickCloseCareerDialog(){
				this.showCareerDialog = false;
			},

			clickAddIndustry(code) {
				let index = this.selectedIndustryCodeList.indexOf(code)
				if (index <= -1) {
					this.selectedIndustryCodeList.push(code)
				}
				this.showValidIndustryList(this.childIndustryList);
			},
			
			clickAddCareer(code) {
				let index = this.selectedCareerCodeList.indexOf(code)
				console.log('clickAddCareer code', code, 'index', index)
				if (index <= -1) {
					this.selectedCareerCodeList.push(code)
				}
					console.log('clickAddCareer selectedCareerCodeList', this.selectedCareerCodeList)
				this.loadCareerList();
			},
			
			clickRemoveCareer(code) {
				let index = this.selectedCareerCodeList.indexOf(code)
				if (index > -1) {
					this.selectedCareerCodeList.splice(index, 1);
				}
				this.loadCareerList();
			},
			

			showValidIndustryList(childIndustryList) {
				let list = [];
				childIndustryList.forEach(item => {
					let index = this.selectedIndustryCodeList.indexOf(item.code)
					if (index <= -1) {
						list.push(item);
					}
				})

				this.childIndustryList = list;
			},

			isIndustrySelected(code) {
				const index = this.selectedIndustryCodeList.indexOf(code)
				if (index > -1) {
					return true;
				}

				return false;
			},

			clickRemoveIndustry(code) {
				const index = this.selectedIndustryCodeList.indexOf(code)
				if (index > -1) {
					this.selectedIndustryCodeList.splice(index, 1) // 删除索引位置的元素
					
					let targetIndex = -1;
					
					let size = this.childIndustryList.length;
					
					for(let i = 0; i < size; i++){
						if(this.childIndustryList[i]['code'] == code){
							targetIndex = i;
							break;
						}
					}
					
					if(targetIndex > -1){
						this.childIndustryList.splice(targetIndex, 1) // 删除索引位置的元素
					}
				}
			},

			clickIndustryTab(index) {
				this.groupAddIndex = index;
				if (this.groupAddList[this.groupAddIndex]['value'] == 1) {
					this.childIndustryList = [];
					this.sectorTree.forEach(top => {
						top.list.forEach(item => {
							if (this.selectedIndustryCodeList.indexOf(item.code) > -1) {
								this.childIndustryList.push(item);
							}
						})
					});
				} else {
					this.sector = this.sectorTree[0]['code'];
					this.changeSector(this.sector);
				}

			},
			
			clickCareerTab(index){
				this.groupAddIndex = index;
				this.loadCareerList();
			},
			
			clickCareer(){
				if(this.selectedIndustryCodeList.length < 1){
					Notification.error({
						title: '请先选择行业'
					})
					return;
				}
				
				this.showCareerDialog = true;
				this.bigIndustryList = [];
				this.sectorTree.forEach(top => {
					top.list.forEach(item => {
						if (this.selectedIndustryCodeList.indexOf(item.code) > -1) {
							this.bigIndustryList.push(item);
						}
					})
				});
				this.dialogIndustry = this.bigIndustryList[0]['code']
				this.loadCareerList();
			},
			
			loadMajorList(query) {
				console.log('loadMajorList query', query)
				getMajorList({
					name: query,
					degree: this.degree
				}).then(res => {
					this.majorList = res.data.majorList;
					this.major = ''
				});
			},
			
			onLevelChange(value){
				this.majorList = [];
				this.major = ''
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "service.scss";
</style>